import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionJointLifeAndSurvivorBenefit } from './monthly-pension-joint-life-and-survivor-benefit';

export class MonthlyPensionJointLifeAnnuityCalculation implements Deserializable {
  public retirementDate!: string | null;
  public equity!: number;
  public memberBirthDate!: string | null;
  public memberAge!: number;
  public memberDaysUntilBirthDate!: number;
  public spousalBirthDate!: string | null;
  public spousalAge!: number;
  public spousalDaysUntilBirthDate!: number;
  public jointLifeAndSurvivorBenefits!: MonthlyPensionJointLifeAndSurvivorBenefit[];

  public onDeserialize(): void {
    this.jointLifeAndSurvivorBenefits = window.injector.Deserialize.arrayOf(
      MonthlyPensionJointLifeAndSurvivorBenefit,
      this.jointLifeAndSurvivorBenefits
    );
  }
}
